/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationResponse } from './OrganizationResponse';
import {
    OrganizationResponseFromJSON,
    OrganizationResponseFromJSONTyped,
    OrganizationResponseToJSON,
    OrganizationResponseToJSONTyped,
} from './OrganizationResponse';
import type { AccessRequestStatus } from './AccessRequestStatus';
import {
    AccessRequestStatusFromJSON,
    AccessRequestStatusFromJSONTyped,
    AccessRequestStatusToJSON,
    AccessRequestStatusToJSONTyped,
} from './AccessRequestStatus';
import type { UserKrrInfoResponse } from './UserKrrInfoResponse';
import {
    UserKrrInfoResponseFromJSON,
    UserKrrInfoResponseFromJSONTyped,
    UserKrrInfoResponseToJSON,
    UserKrrInfoResponseToJSONTyped,
} from './UserKrrInfoResponse';
import type { AltinnResponse } from './AltinnResponse';
import {
    AltinnResponseFromJSON,
    AltinnResponseFromJSONTyped,
    AltinnResponseToJSON,
    AltinnResponseToJSONTyped,
} from './AltinnResponse';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

/**
 * 
 * @export
 * @interface AccessRequestResponse
 */
export interface AccessRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    receiptCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    applicationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    applicationDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    requestedByUserId?: string | null;
    /**
     * 
     * @type {UserType}
     * @memberof AccessRequestResponse
     */
    requestedByUserType?: UserType;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    requestedByUserName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestResponse
     */
    isRequestedByUserIdPortenVerified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    requestedByUserMfaPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    employer?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestResponse
     */
    createdOn?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestResponse
     */
    modifiedOn?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AccessRequestResponse
     */
    processedOn?: Date | null;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestResponse
     */
    requestedRoleId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    requestedRoleName?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestResponse
     */
    requestedPermissionId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    requestedPermissionName?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestResponse
     */
    assignedRoleId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    assignedRoleName?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestResponse
     */
    assignedPermissionId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestResponse
     */
    assignedPermissionName?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AccessRequestResponse
     */
    organizationId?: any | null;
    /**
     * 
     * @type {OrganizationResponse}
     * @memberof AccessRequestResponse
     */
    organization?: OrganizationResponse;
    /**
     * 
     * @type {AltinnResponse}
     * @memberof AccessRequestResponse
     */
    altinn?: AltinnResponse;
    /**
     * 
     * @type {UserKrrInfoResponse}
     * @memberof AccessRequestResponse
     */
    userKrr?: UserKrrInfoResponse;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestResponse
     */
    isEmployerVerified?: boolean;
    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof AccessRequestResponse
     */
    status?: AccessRequestStatus;
}



/**
 * Check if a given object implements the AccessRequestResponse interface.
 */
export function instanceOfAccessRequestResponse(value: object): value is AccessRequestResponse {
    return true;
}

export function AccessRequestResponseFromJSON(json: any): AccessRequestResponse {
    return AccessRequestResponseFromJSONTyped(json, false);
}

export function AccessRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'receiptCode': json['receiptCode'] === undefined ? undefined : json['receiptCode'] === null ? null : json['receiptCode'],
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'applicationName': json['applicationName'] === undefined ? undefined : json['applicationName'] === null ? null : json['applicationName'],
        'applicationDescription': json['applicationDescription'] === undefined ? undefined : json['applicationDescription'] === null ? null : json['applicationDescription'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'requestedByUserId': json['requestedByUserId'] === undefined ? undefined : json['requestedByUserId'] === null ? null : json['requestedByUserId'],
        'requestedByUserType': json['requestedByUserType'] == null ? undefined : UserTypeFromJSON(json['requestedByUserType']),
        'requestedByUserName': json['requestedByUserName'] === undefined ? undefined : json['requestedByUserName'] === null ? null : json['requestedByUserName'],
        'isRequestedByUserIdPortenVerified': json['isRequestedByUserIdPortenVerified'] == null ? undefined : json['isRequestedByUserIdPortenVerified'],
        'requestedByUserMfaPhone': json['requestedByUserMfaPhone'] === undefined ? undefined : json['requestedByUserMfaPhone'] === null ? null : json['requestedByUserMfaPhone'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'employer': json['employer'] === undefined ? undefined : json['employer'] === null ? null : json['employer'],
        'createdOn': json['createdOn'] == null ? undefined : (new Date(json['createdOn'])),
        'modifiedOn': json['modifiedOn'] === undefined ? undefined : json['modifiedOn'] === null ? null : (new Date(json['modifiedOn'])),
        'processedOn': json['processedOn'] === undefined ? undefined : json['processedOn'] === null ? null : (new Date(json['processedOn'])),
        'requestedRoleId': json['requestedRoleId'] === undefined ? undefined : json['requestedRoleId'] === null ? null : json['requestedRoleId'],
        'requestedRoleName': json['requestedRoleName'] === undefined ? undefined : json['requestedRoleName'] === null ? null : json['requestedRoleName'],
        'requestedPermissionId': json['requestedPermissionId'] === undefined ? undefined : json['requestedPermissionId'] === null ? null : json['requestedPermissionId'],
        'requestedPermissionName': json['requestedPermissionName'] === undefined ? undefined : json['requestedPermissionName'] === null ? null : json['requestedPermissionName'],
        'assignedRoleId': json['assignedRoleId'] === undefined ? undefined : json['assignedRoleId'] === null ? null : json['assignedRoleId'],
        'assignedRoleName': json['assignedRoleName'] === undefined ? undefined : json['assignedRoleName'] === null ? null : json['assignedRoleName'],
        'assignedPermissionId': json['assignedPermissionId'] === undefined ? undefined : json['assignedPermissionId'] === null ? null : json['assignedPermissionId'],
        'assignedPermissionName': json['assignedPermissionName'] === undefined ? undefined : json['assignedPermissionName'] === null ? null : json['assignedPermissionName'],
        'organizationId': json['organizationId'] === undefined ? undefined : json['organizationId'] === null ? null : json['organizationId'],
        'organization': json['organization'] == null ? undefined : OrganizationResponseFromJSON(json['organization']),
        'altinn': json['altinn'] == null ? undefined : AltinnResponseFromJSON(json['altinn']),
        'userKrr': json['userKrr'] == null ? undefined : UserKrrInfoResponseFromJSON(json['userKrr']),
        'isEmployerVerified': json['isEmployerVerified'] == null ? undefined : json['isEmployerVerified'],
        'status': json['status'] == null ? undefined : AccessRequestStatusFromJSON(json['status']),
    };
}

export function AccessRequestResponseToJSON(json: any): AccessRequestResponse {
    return AccessRequestResponseToJSONTyped(json, false);
}

export function AccessRequestResponseToJSONTyped(value?: AccessRequestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'receiptCode': value['receiptCode'],
        'applicationId': value['applicationId'],
        'applicationName': value['applicationName'],
        'applicationDescription': value['applicationDescription'],
        'description': value['description'],
        'requestedByUserId': value['requestedByUserId'],
        'requestedByUserType': UserTypeToJSON(value['requestedByUserType']),
        'requestedByUserName': value['requestedByUserName'],
        'isRequestedByUserIdPortenVerified': value['isRequestedByUserIdPortenVerified'],
        'requestedByUserMfaPhone': value['requestedByUserMfaPhone'],
        'email': value['email'],
        'employer': value['employer'],
        'createdOn': value['createdOn'] == null ? value['createdOn'] : value['createdOn'].toISOString(),
        'modifiedOn': value['modifiedOn'] == null ? value['modifiedOn'] : value['modifiedOn'].toISOString(),
        'processedOn': value['processedOn'] == null ? value['processedOn'] : value['processedOn'].toISOString(),
        'requestedRoleId': value['requestedRoleId'],
        'requestedRoleName': value['requestedRoleName'],
        'requestedPermissionId': value['requestedPermissionId'],
        'requestedPermissionName': value['requestedPermissionName'],
        'assignedRoleId': value['assignedRoleId'],
        'assignedRoleName': value['assignedRoleName'],
        'assignedPermissionId': value['assignedPermissionId'],
        'assignedPermissionName': value['assignedPermissionName'],
        'organizationId': value['organizationId'],
        'organization': OrganizationResponseToJSON(value['organization']),
        'altinn': AltinnResponseToJSON(value['altinn']),
        'userKrr': UserKrrInfoResponseToJSON(value['userKrr']),
        'isEmployerVerified': value['isEmployerVerified'],
        'status': AccessRequestStatusToJSON(value['status']),
    };
}

